// 首页的接口
import request from '../utils/request'

// 获取轮播列表接口
function bannerList(data) {
    return request({
        method: 'get',
        url: '/api/banner/lists',
        params:data
    })
}
// 获取项目列表接口
function projectList(data) {
    return request({
        method: 'get',
        url: '/api/projectcase/lists',
        params:data
    })
}
// 获取项目详情接口
function projectDetail(data) {
    return request({
        method: 'get',
        url: '/api/projectcase/detail',
        params:data
    })
}
// 获取公司简介接口
function companyDetail(data) {
    return request({
        method: 'get',
        url: '/api/video/lists',
        params:data
    })
}
// 获取荣誉列表接口
function honorList(data) {
    return request({
        method: 'get',
        url: '/api/honor/lists',
        params:data
    })
}
// 获取新闻列表接口
function newsList(data) {
    return request({
        method: 'get',
        url: '/api/news/lists',
        params:data
    })
}
// 获取新闻详情接口
function newsDetail(data) {
    return request({
        method: 'get',
        url: '/api/news/detail',
        params:data
    })
}
// 获取招聘信息列表接口
function joinList(data) {
    return request({
        method: 'get',
        url: '/api/recruit/lists',
        params:data
    })
}

export {
    bannerList,
    projectList,
    projectDetail,
    companyDetail,
    honorList,
    newsList,
    newsDetail,
    joinList
}


// WEBPACK FOOTER //
// ./src/api/index.js